import React from 'react';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { SectionContainer } from 'components/Containers/SectionContainer/SectionContainer';
import LifeInsuranceFilters from 'partial/OfferManager/modules/LifeInsuranceModule/components/LifeInsuranceFilters';
import LifeInsuranceOfferView from 'partial/OfferManager/modules/LifeInsuranceModule/components/LifeInsuranceOfferView';
import Label from 'components/form/Label/Label';
import 'partial/OfferManager/modules/LifeInsuranceModule/LifeInsuranceModule.style.scss';
import './LifeInsuranceOcfModuleView.scss';
import { Image } from 'components/Image/Image';
import 'partial/OfferManager/modules/LifeInsuranceModule/LifeInsuranceModule.style.scss';
import MoreWaysToBrowseCard from 'pages/Ocf/components/MoreWaysToBrowseCard';

export const LifeInsuranceOcfModuleView = props => {
  return (
    <>
      <SectionContainer
        className={'lifeInsuranceOcfContainer new-life-insurance-marketplace'}
      >
        <FlexContainer
          className={
            ' headerContainer padLR48 m-padLR16 justify-between m-margB8 margB32'
          }
        >
          <FlexContainer className={'flex-column margT54 m-margT0'}>
            <Label className={'H3 m-H3'}>{'Plan for the future.'}</Label>
            <Label className={'Body-1 margT8 mBody-2'}>
              {
                'Find a life insurance policy that can take care of your loved ones, cover expenses, and provide peace of mind.'
              }
            </Label>
          </FlexContainer>
          <FlexContainer className={'m-hide'}>
            <Image imgClass={'lifeInsuranceImage bgImageW225'} />
          </FlexContainer>
        </FlexContainer>
        <LifeInsuranceFilters {...props} />
        <LifeInsuranceOfferView {...props} />
      </SectionContainer>
      <MoreWaysToBrowseCard />
    </>
  );
};
